import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

/**
 * The standing password guidance on the sign-up screen's "Choose your password"
 * label — the rule, the advice, and the password-manager recommendation.
 *
 * Rendered as a `FormItem` tooltip's content rather than a component, so it sits
 * on the label's own info mark like every other explanation on these screens.
 *
 * This is guidance you can read BEFORE typing, which is the point: the
 * validation message and the strength tip both arrive only after you have
 * already chosen something.
 */
export const authenticationPasswordGuidance = (
  <Stack gap={2}>
    <T weight="bold">Passwords</T>
    <T size="xs" color="secondary">
      Your password must be at least 8 characters, and must not be a common word
      or phrase
    </T>
    <T size="xs" color="secondary">
      We recommend picking something that would be hard to guess and using a
      variety of lowercase letters, capital letters and numbers
    </T>
    <T size="xs" color="secondary">
      We also strongly recommend using a password manager
    </T>
  </Stack>
);
